import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const SiteListPage = () =>
  import('@modules/site/components/site-list-page.vue');
const SiteFormPage = () =>
  import('@modules/site/components/site-form-page.vue');
const SiteViewPage = () =>
  import('@modules/site/components/site-view-page.vue');
const SiteImporterPage = () =>
  import('@modules/site/components/site-importer-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'site',
        path: '/site',
        component: SiteListPage,
        meta: {
          auth: true,
          permission: Permissions.values.siteView,
        },
      },
      {
        name: 'siteNew',
        path: '/site/new',
        component: SiteFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.siteCreate,
        },
      },
      {
        name: 'siteImporter',
        path: '/site/import',
        component: SiteImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.siteImport,
        },
      },
      {
        name: 'siteEdit',
        path: '/site/:id/edit',
        component: SiteFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.siteEdit,
        },
        props: true,
      },
      {
        name: 'siteView',
        path: '/site/:id',
        component: SiteViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.siteView,
        },
        props: true,
      },
    ],
  },
];
